/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Company\FindCompany\FindCompany.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday January 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday January 16th 2024 9:30:39 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Autocomplete, TextField } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";
import CompanyService from "Services/CompanyService/CompanyService";
import { CompanyDataType } from "Type/company.type";
import { QueryParams } from "Type/queryParams";
import { useEffect, useMemo, useRef, useState } from "react";

type FindCompanyProps = {
    setCompany: Function,
    setSearchTerm?: Function,
    searchTerm?: string,
    queryParams?: QueryParams,
}

const FindCompany = (props: FindCompanyProps) => {
    const [companyValue, setCompanyValue] = useState<string | null>(null);
    const [companiesOptions, setCompaniesOptions] = useState<{result: CompanyDataType, label: string}[]>([]);
    const [companyInputValue, setCompanyInputValue] = useState<string>(props.searchTerm ? decodeURIComponent(props.searchTerm) : "");
    const firstLoad = useRef(true);

    const selectedCompany = useMemo(() => {
        let optionFound =  companiesOptions.filter((v) => v.label === companyValue);
        if (optionFound.length > 0)
            return optionFound[0].label;
        return companyValue;
    }, [companyInputValue]);

    const selectableCompanyOptions = useMemo(() => {
        return companiesOptions.map(v => v.label);
    }, [companiesOptions]);

    // useEffect(() => {
    //     if (firstLoad.current && props.setSearchTerm)
    //         props.setSearchTerm(companyInputValue);
    // }, [companyInputValue]);

    useEffect(() => {
        const beforeSearch = setTimeout(async () => {
            searchCompanyOptions(companyInputValue);
        }, 500);
        return () => clearTimeout(beforeSearch);
    }, [companyInputValue]);

    const searchCompanyOptions = async (companySearchTerm: string) => {
        if (companySearchTerm.length >= 3 && companiesOptions.findIndex((val) => val.label === companySearchTerm) === -1) {
            let searchOptions = await CompanyService.getCompanyBySearch(companySearchTerm);
            if (searchOptions)
                setCompaniesOptions(searchOptions);
        }
    };

    return (
        <Autocomplete
            freeSolo
            value={selectedCompany}
            onChange={async (event: any, newValue: string | null) => {
                setCompanyValue(newValue);
                if (newValue)
                    props.setCompany(companiesOptions.filter((v) => v.label === newValue)[0].result);
                else
                    props.setCompany(undefined);
            }}
            inputValue={companyInputValue}
            filterOptions={x => x}
            // onClickCapture={async () => {
            //     await searchCompanyOptions(companyInputValue);
            // }}
            onInputChange={async (event, newcompanyValue) => {
                // await searchCompanyOptions(newcompanyValue);
                setCompanyInputValue(newcompanyValue);
            }}
            id="combo-box-company"
            options={selectableCompanyOptions}
            sx={{ width: 300, backgroundColor:"white" }}
            renderInput={(params) => <TextField autoFocus {...params} label={`${translator.decode("dynamic.company")}`} />}
        />
    )
}

export default FindCompany;
